<template>
  <div>
    <el-form-item label="账号名称"
                  prop="name">
      <el-input v-model="formData.name"
                placeholder="系统登录账号名称"></el-input>
    </el-form-item>
    <el-form-item label="姓名"
                  prop="realname">
      <el-input v-model="formData.realname"
                placeholder="请输入姓名"></el-input>
    </el-form-item>
    <el-form-item label="密码"
                  prop="password">
      <template v-if="pageType === 'create'">
        <span>默认密码为 {{ formData.password }}</span>
      </template>
      <el-input v-model="formData.password"
                v-else
                placeholder="无需修改密码时请留空"></el-input>
    </el-form-item>
    <el-form-item label="人员性质"
                  prop="employment_type">
      <el-select v-model="formData.employment_type"
                 placeholder="请选择人员性质"
                 style="width: 100%;">
        <el-option v-for="(label, value) in employmentTypeMap"
                   :key="value"
                   :label="label"
                   :value="Number(value)"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="账号状态"
                  prop="status">
      <template v-if="pageType === 'create'">
        <span>{{ statusMap[formData.status] || '' }}</span>
      </template>
      <el-select v-model="formData.status"
                 v-else
                 placeholder="请选择账号状态"
                 style="width: 100%;">
        <el-option v-for="(label, value) in statusMap"
                   :key="value"
                   :label="label"
                   :value="Number(value)"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="手机号"
                  prop="phone">
      <el-input v-model="formData.phone"
                placeholder="请输入手机号"></el-input>
    </el-form-item>
    <el-form-item label="个人邮箱"
                  prop="mail_address">
      <el-input v-model="formData.mail_address"
                placeholder="请输入个人邮箱"></el-input>
    </el-form-item>
    <el-form-item label="办公地点"
                  prop="office_location">
      <el-select v-model="formData.office_location"
                 placeholder="请选择办公地点"
                 clearable
                 style="width: 100%;">
        <el-option v-for="(label, value) in officeLocationMap"
                   :key="value"
                   :label="label"
                   :value="Number(value)"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="目前所在院校"
                  prop="school">
      <el-input v-model="formData.school"
                placeholder="请输入院校名称"></el-input>
    </el-form-item>
    <el-form-item label="专业"
                  prop="major">
      <el-input v-model="formData.major"
                placeholder="请输入专业"></el-input>
    </el-form-item>
    <el-form-item label="学历"
                  prop="education_level">
      <el-select v-model="formData.education_level"
                 placeholder="请选择学历"
                 clearable
                 style="width: 100%;">
        <el-option v-for="(label, value) in educationLevelMap"
                   :key="value"
                   :label="label"
                   :value="Number(value)"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="当前学年段"
                  prop="grade_level">
      <el-select v-model="formData.grade_level"
                 placeholder="请选择当前学年段"
                 clearable
                 style="width: 100%;">
        <el-option v-for="(label, value) in gradeLevelMap"
                   :key="value"
                   :label="label"
                   :value="Number(value)"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="学生证照片"
                  prop="student_card_photos">
      <el-upload ref="studentCardUpload"
                 class="upload-demo"
                 :auto-upload="false"
                 action=""
                 :file-list="studentCardPhotoList"
                 list-type="picture-card"
                 accept=".jpg,.jpeg,.png"
                 :on-change="(file, fileList) => onChangeFile(file, fileList, 'student_card_photos')"
                 :on-remove="(file, fileList) => handleRemove(file, fileList, 'student_card_photos')">
        <i class="el-icon-plus"></i>
      </el-upload>
    </el-form-item>
    <el-form-item label="合同时间"
                  prop="contract_start_date">
      <el-date-picker v-model="contractDateRange"
                      type="daterange"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd"
                      style="width: 100%;">
      </el-date-picker>
    </el-form-item>
    <el-form-item label="备注"
                  prop="remark">
      <el-input v-model="formData.remark"
                type="textarea"
                :rows="4"
                placeholder="请输入备注信息">
      </el-input>
    </el-form-item>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    pageType: {
      type: String,
      default: 'create'
    },
    internId: {
      type: String,
      default: '0',
    },
  },
  data () {
    return {
      studentCardPhotoList: []
    }
  },
  watch: {
    'formData.student_card_photos': {
      handler (newVal) {
        // 只在 studentCardPhotoList 为空时初始化，避免后续操作导致闪烁
        if (this.studentCardPhotoList.length === 0 && newVal && newVal.length > 0) {
          this.studentCardPhotoList = newVal.map(url => ({url, status: 'ready'}))
        }
      },
      immediate: true
    }
  },
  computed: {
    formData: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    contractDateRange: {
      get () {
        return [this.formData.contract_start_date || '', this.formData.contract_end_date || '']
      },
      set (val) {
        if (val && val.length === 2) {
          this.$set(this.formData, 'contract_start_date', val[0])
          this.$set(this.formData, 'contract_end_date', val[1])
        } else {
          this.$set(this.formData, 'contract_start_date', '')
          this.$set(this.formData, 'contract_end_date', '')
        }
      }
    },
    ...Vuex.mapState({
      employmentTypeMap: state => state.auditIntern.employmentTypeMap,
      educationLevelMap: state => state.auditIntern.educationLevelMap,
      officeLocationMap: state => state.auditIntern.officeLocationMap,
      gradeLevelMap: state => state.auditIntern.gradeLevelMap,
      statusMap: state => state.auditIntern.statusMap,
    })
  },
  methods: {
    reset () {
      // 清空表单数据
      this.studentCardPhotoList = []
    },
    handleRemove (file, fileList, field) {
      if (field === 'student_card_photos') {
        // 同时更新 photoList 和 formData
        this.studentCardPhotoList = fileList.map(item => ({...item, status: 'ready'}))
        this.formData[field] = fileList.map(item => item.response || item.url)
      }
    },
    async onChangeFile (file, fileList, field) {
      const isImage = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png'
      const isLt10M = file.raw.size / 1024 / 1024 < 10
      if (!isImage) {
        this.$message.error('请上传jpg/png图片!')
        this.removeInvalidFile(file, fileList, field)
        return false
      }
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!')
        this.removeInvalidFile(file, fileList, field)
        return false
      }
      const fieldMap = {
        'student_card_photos': 'intern_studentcard'
      }
      const apiField = _.get(fieldMap, field, field)

      try {
        const result = await this.uploadFile(file.raw, apiField)
        if (result.success) {
          // 上传成功，更新最后一个文件的 response
          const lastFile = fileList[fileList.length - 1]
          lastFile.response = result.url
          // 同时更新 photoList 和 formData，设置status为success隐藏绿色对勾
          this.studentCardPhotoList = fileList.map(item => ({...item, status: 'ready'}))
          this.formData[field] = fileList.map(item => item.response || item.url)
        } else {
          this.$message.error(result.error || '上传失败')
          this.removeInvalidFile(file, fileList, field)
        }
      } catch (err) {
        this.$message.error(err.message || '上传失败')
        this.removeInvalidFile(file, fileList, field)
      }
    },
    removeInvalidFile (file, fileList, field) {
      const index = fileList.indexOf(file)
      if (index > -1) {
        fileList.splice(index, 1)
        if (field === 'student_card_photos') {
          // 同时更新 photoList 和 formData
          this.studentCardPhotoList = fileList
          this.formData[field] = fileList.map(item => item.response || item.url)
        }
      }
    },
    getExtByBlob (blob) {
      const fileName = blob.name
      return fileName.substring(fileName.lastIndexOf('.')).toLowerCase()
    },
    async uploadFile (file, field) {
      try {
        const blob = file.raw || file
        // 获取签名URL
        const params = {
          intern_id: this.internId,
          ext: this.getExtByBlob(blob),
          content_type: blob.type,
          oss_tpl: field
        }
        const res = await request.common('getOssSignedUrlApi', params)

        if (res.status === 200) {
          const uploadUrl = res.data.signedUrl
          const contentType = res.data.content_type
          const fileUrl = res.data.url
          // 上传文件到签名URL
          const uploadRes = await fetch(uploadUrl, {
            method: 'PUT',
            headers: new Headers({'Content-Type': contentType}),
            body: blob
          })
          if (!uploadRes.ok) {
            return {success: false, error: `上传失败: ${uploadRes.status} ${uploadRes.statusText}`}
          } else {
            return {success: true, url: fileUrl}
          }
        }
        return {success: false, error: '获取上传地址失败'}
      } catch (err) {
        return {success: false, error: err.message || '上传失败'}
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/audit-intern/components/BaseInfoForm.vue